// extracted by mini-css-extract-plugin
module.exports = {"rateRemindText":"index_rateRemindText_7Hm4_","primaryStyle":"index_primaryStyle_1nYlM"};